import { z } from 'zod';

export const dealerSecretSettingSchema = z.object({
    secret: z
        .string()
        .trim()
        .min(8, 'Key must be at least 8 characters')
        .max(512, 'Key must be at most 512 characters')
        .regex(/^\S+$/, 'Key must not contain whitespace'),
});

export type DealerSecretSettingFormInput = z.input<typeof dealerSecretSettingSchema>;
export type DealerSecretSettingFormOutput = z.output<typeof dealerSecretSettingSchema>;
